(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const section = document.querySelector('[data-pdp-section]');
  if (!section) return;

  const productJsonEl = section.querySelector('[data-product-json]');
  const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
  if (!product) return;

  function readJson(selector) {
    const el = section.querySelector(selector);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  // Every visible label comes from locales via the section; an empty string is a
  // valid translation, so we never substitute an English fallback here.
  const strings = readJson('[data-pdp-strings]');
  const prices = readJson('[data-pdp-prices]');

  function label(key) {
    return Object.prototype.hasOwnProperty.call(strings, key) ? strings[key] : '';
  }

  /* ═══════════════════════════════════════════
     Gallery: swipe + dash sync + counter
     ═══════════════════════════════════════════ */
  /* Slides 2 en verder dragen hun adres in data-gal-src, zodat ze niet met de
     LCP-foto om bandbreedte vechten. Deze functie zet ze aan: bij de eerste
     aanraking van de galerij, en anders vanzelf kort na window load — dan is
     de eerste foto binnen en is de lijn vrij. Hij staat los van initGallery
     omdat die bij één media-item meteen stopt. */
  let beeldenGewekt = false;
  function wekSlides() {
    if (beeldenGewekt) return;
    beeldenGewekt = true;
    document.querySelectorAll('img[data-gal-src]').forEach((img) => {
      img.srcset = img.dataset.galSrcset || '';
      img.src = img.dataset.galSrc;
      img.removeAttribute('data-gal-src');
      img.removeAttribute('data-gal-srcset');
    });
  }

  function initSlideWake() {
    const track = document.querySelector('[data-gal-track]');
    if (track) {
      ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach((ev) =>
        track.addEventListener(ev, wekSlides, { once: true, passive: true })
      );
    }
    // Vangnet: ook zonder aanraking horen de foto's er te staan, bijvoorbeeld
    // als een variantwissel naar een andere slide springt of iemand deelt.
    const later = () => setTimeout(wekSlides, 600);
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  }

  function initGallery() {
    const track = section.querySelector('[data-gal-track]');
    if (!track) return;

    const slides = track.querySelectorAll('[data-gal-slide]');
    const dots = section.querySelectorAll('[data-gal-dot]');
    const counterCur = section.querySelector('[data-gal-cur]');
    const fill = section.querySelector('[data-gal-fill]');
    if (slides.length < 2) return;

    function setActive(index) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      if (counterCur) counterCur.textContent = String(index + 1).padStart(2, '0');
      if (fill) fill.style.width = ((index + 1) / slides.length * 100) + '%';
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        wekSlides();
        const slide = slides[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
        setActive(i);
      });
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.offsetWidth);
        setActive(idx);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ═══════════════════════════════════════════
     Variant sync: color + size → update buybox
     ═══════════════════════════════════════════ */
  function initVariants() {
    const colorBtns = section.querySelectorAll('[data-color-value]:not(em)');
    const sizeBtns = section.querySelectorAll('[data-size-value]');
    const variantInput = section.querySelector('[data-variant-id]');
    const atc = section.querySelector('[data-pdp-atc]');
    const priceEl = section.querySelector('[data-pdp-price]');
    const priceNow = section.querySelector('.bellascena-pdp__price-now');
    const priceWas = section.querySelector('.bellascena-pdp__price-was');
    const priceBadge = section.querySelector('[data-pdp-badge]');
    const saleNote = section.querySelector('[data-pdp-save]');
    const saleAmt = section.querySelector('[data-save-amt]');
    const stickyBar = section.querySelector('[data-pdp-sticky]');
    const stickyAtc = section.querySelector('[data-pdp-sticky-atc]');
    const stickyAtcText = section.querySelector('[data-sticky-atc-text]');
    const stickySelect = section.querySelector('[data-pdp-sticky-size]');
    const stickySizeValue = section.querySelector('[data-pdp-sticky-size-value]');
    const stickyColorSelect = section.querySelector('[data-pdp-sticky-color]');
    const stickySwatch = section.querySelector('[data-pdp-sticky-swatch]');
    const stickyThumbImg = section.querySelector('.bellascena-pdp__sticky-thumb img');

    // De keuzelijst in de sticky balk en de maatknoppen in de buybox tonen
    // dezelfde keuze. De knoppen blijven de bron van waarheid — findVariant
    // leest die — dus de lijst zet ze om en leest ze daarna weer terug.
    function syncStickySelect() {
      if (!stickySelect) return;
      const oi = stickySelect.getAttribute('data-option-index');
      const active = section.querySelector('button[data-size-value][data-option-index="' + oi + '"].is-active');
      if (active) stickySelect.value = active.getAttribute('data-size-value');
      // Het veld is onzichtbaar, dus de maat die je leest staat in deze span.
      // Niet de optietekst, want die luidt bij uitverkocht "M — uitverkocht",
      // en niet de value, want die staat altijd in centimeters. data-label is
      // de maat zoals de klant hem hoort te lezen.
      if (stickySizeValue) {
        const opt = stickySelect.options[stickySelect.selectedIndex];
        stickySizeValue.textContent = (opt && opt.dataset.label) || stickySelect.value;
      }
    }

    function syncStickyColor() {
      if (!stickyColorSelect) return;
      const oi = stickyColorSelect.getAttribute('data-option-index');
      const active = section.querySelector('button[data-color-value][data-option-index="' + oi + '"].is-active');
      if (!active) return;
      stickyColorSelect.value = active.getAttribute('data-color-value');
      // De swatch in de buybox is al ingekleurd; die stijl kopiëren we, zodat de
      // kleurenlijst maar op één plek in het theme staat. De kleur staat op de
      // span bínnen de knop — op de knop zelf staat niets, en dat wiste het
      // bolletje bij de eerste de beste wijziging.
      const box = active.querySelector('.bellascena-pdp__swatch-box');
      if (stickySwatch && box) stickySwatch.setAttribute('style', box.getAttribute('style') || '');
    }

    if (stickySelect) {
      stickySelect.addEventListener('change', () => {
        const chosen = stickySelect.selectedOptions[0];
        // Een uitverkochte maat kiezen opent hetzelfde bericht-mij venster als
        // een uitverkochte knop, en draait de lijst daarna terug.
        if (chosen && chosen.getAttribute('data-oos') === 'true') {
          openNotifyMe(stickySelect.value);
          syncStickySelect();
          return;
        }
        const oi = stickySelect.getAttribute('data-option-index');
        section.querySelectorAll('button[data-size-value][data-option-index="' + oi + '"]').forEach(b => {
          const active = b.getAttribute('data-size-value') === stickySelect.value;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        updateUI();
      });
    }

    if (stickyColorSelect) {
      stickyColorSelect.addEventListener('change', () => {
        const oi = stickyColorSelect.getAttribute('data-option-index');
        // De swatch-knop aanklikken in plaats van hier zelf de klasse omzetten:
        // die knop werkt ook de kleurnaam boven de swatches bij.
        const target = Array.from(
          section.querySelectorAll('button[data-color-value][data-option-index="' + oi + '"]')
        ).find(b => b.getAttribute('data-color-value') === stickyColorSelect.value);
        if (target) target.click();
      });
    }

    const colorNameEl = section.querySelector('.bellascena-pdp__opt-label em[data-color-value]');
    const ctaText = section.querySelector('[data-atc-text]');
    const saleText = section.querySelector('[data-save-text]');

    function selected(type) {
      const el = section.querySelector(`button[data-${type}-value].is-active`);
      return el ? el.getAttribute(`data-${type}-value`) : null;
    }

    function findVariant() {
      // Position-aware match across ALL option groups (handles multi-size sets: bra size + thong size + colour)
      const sel = {};
      section.querySelectorAll('button[data-option-index].is-active').forEach(b => {
        const oi = Number(b.getAttribute('data-option-index'));
        const val = b.getAttribute('data-size-value') || b.getAttribute('data-color-value');
        if (val != null && !Number.isNaN(oi)) sel[oi] = val;
      });
      const keys = Object.keys(sel);
      return product.variants.find(v => keys.every(oi => v.options[Number(oi)] === sel[oi]));
    }

    function updateUI() {
      const v = findVariant();
      if (!v) return;

      syncStickySelect();
      syncStickyColor();

      // Prices come pre-formatted from Liquid, so currency and separators follow the market.
      const money = prices[String(v.id)] || {};

      if (variantInput) variantInput.value = v.id;

      if (priceNow && money.price) priceNow.textContent = money.price;

      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceEl) priceEl.classList.toggle('is-sale', !!onSale);

      if (priceWas) {
        if (onSale && money.compare) {
          priceWas.textContent = money.compare;
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      if (priceBadge) {
        if (onSale) {
          priceBadge.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          priceBadge.style.display = '';
        } else {
          priceBadge.style.display = 'none';
        }
      }

      if (saleNote) {
        if (onSale) {
          // The whole sentence is the translation; only the amount token is ours to fill.
          const tpl = saleText ? saleText.getAttribute('data-save-tpl') : null;
          if (saleText && tpl) saleText.innerHTML = tpl.replace('__amount__', money.save || '');
          else if (saleAmt && money.save) saleAmt.textContent = money.save;
          saleNote.style.display = '';
        } else {
          saleNote.style.display = 'none';
        }
      }

      // Mirror availability into the sticky mobile bar
      if (stickyAtc) {
        stickyAtc.disabled = !v.available;
        if (stickyAtcText) stickyAtcText.textContent = v.available ? label('add_short') : label('sold_out');
      }

      if (atc) {
        atc.disabled = !v.available;
        if (ctaText) ctaText.textContent = v.available ? label('add_to_cart') : label('sold_out');
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);

      // Swap gallery to this variant's featured image (or back to first image if variant has none)
      const targetIdx = (v.featured_media && v.featured_media.position)
        ? v.featured_media.position - 1
        : 0;
      const track = section.querySelector('[data-gal-track]');
      const targetSlide = section.querySelector(`[data-gal-slide="${targetIdx}"]`);
      if (track && targetSlide) {
        wekSlides();
        track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        section.querySelectorAll('[data-gal-slide]').forEach((s, i) => s.classList.toggle('is-active', i === targetIdx));
        section.querySelectorAll('[data-gal-dot]').forEach((d, i) => d.classList.toggle('is-active', i === targetIdx));
      }

      // Het duimpje in de sticky balk toont dezelfde foto als de galerij. De
      // bron komt uit de slide zelf: die afbeelding is al geladen, dus het
      // wisselen kost geen nieuwe download en er is geen tweede lijst met
      // variantfoto's om bij te houden.
      if (stickyThumbImg && targetSlide) {
        const slideImg = targetSlide.querySelector('img');
        const src = slideImg && slideImg.getAttribute('src');
        if (src) stickyThumbImg.setAttribute('src', src);
      }
    }

    function selectBtn(btns, value, typeAttr) {
      btns.forEach(b => {
        const active = b.getAttribute(typeAttr) === value;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    colorBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.getAttribute('data-color-value');
        selectBtn(colorBtns, value, 'data-color-value');
        // Leestekst = het vertaalde label (gekoppelde kleuren vertalen via het
        // metaobject-label, zie bellascena-kleurnaam.liquid); de value blijft
        // rauw, want daar matcht findVariant op.
        if (colorNameEl) colorNameEl.textContent = '· ' + (btn.getAttribute('data-color-label') || value);
        updateUI();
      });
    });

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.getAttribute('data-oos') === 'true') {
          openNotifyMe(btn.getAttribute('data-size-value'));
          return;
        }
        // Activate only within THIS option group so each size dimension (bra / thong) stays independent
        const oi = btn.getAttribute('data-option-index');
        section.querySelectorAll('button[data-size-value][data-option-index="' + oi + '"]').forEach(b => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        updateUI();
      });
    });

    // Sticky mobile bar: reuse the main Add-to-bag (adds + opens the cart drawer)
    if (stickyAtc && atc) {
      stickyAtc.addEventListener('click', () => { if (!atc.disabled) atc.click(); });
    }

    // Reveal the sticky bar once the main CTA has scrolled above the viewport
    if (stickyBar && atc) {
      let ticking = false;
      const syncSticky = () => {
        const past = atc.getBoundingClientRect().bottom < 0;
        stickyBar.classList.toggle('is-visible', past);
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(syncSticky);
      }, { passive: true });
      syncSticky();

      // Hide the sticky bar while a drawer/modal locks page scroll (menu, cart, search)
      var lockObserver = new MutationObserver(function () {
        stickyBar.classList.toggle('is-locked', document.body.style.overflow === 'hidden');
      });
      lockObserver.observe(document.body, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* ═══════════════════════════════════════════
     Notify-me placeholder (logs email capture)
     ═══════════════════════════════════════════ */
  function openNotifyMe(size) {
    const email = window.prompt(label('notify_prompt').replace('__size__', size));
    if (!email) return;
    console.log('[Bellascena] notify-me capture:', { size, email, product: product.handle });
    window.alert(label('notify_confirm').replace('__size__', size));
  }

  /* Wishlist is handled by the global bellascena-wishlist.js module
     (listens for [data-wishlist-toggle] and syncs .is-saved state). */

  /* ═══════════════════════════════════════════
     Fit Finder — 3-question quiz
     ═══════════════════════════════════════════ */
  function initFitFinder() {
    const ff = document.getElementById('bellascena-fit-finder');
    if (!ff) return;

    const openers = document.querySelectorAll('[data-open-fit-finder]');
    const closers = ff.querySelectorAll('[data-ff-close]');
    const nextBtn = ff.querySelector('[data-ff-next]');
    const skipBtn = ff.querySelector('[data-ff-skip]');
    const steps = ff.querySelectorAll('[data-ff-step]');
    const dots = ff.querySelectorAll('[data-ff-progress] span');
    const options = ff.querySelectorAll('.bellascena-pdp__ff-opt');

    const state = { current: 0, answers: { usual: '', band: '', cup: '', fit: '', note: '' } };

    function showStep(i) {
      steps.forEach((s) => {
        const key = s.getAttribute('data-ff-step');
        const active = (i === 3 && key === 'result') || String(i + 1) === key;
        s.classList.toggle('is-active', active);
      });
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx <= i && i < 3));
      if (nextBtn) nextBtn.textContent = i === 2 ? 'See my size →' : (i === 3 ? 'Close' : 'Next →');
    }

    function open() {
      ff.hidden = false;
      requestAnimationFrame(() => ff.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    }
    function close() {
      ff.classList.remove('is-open');
      document.body.style.overflow = '';
      if (reducedMotion) { ff.hidden = true; return; }
      setTimeout(() => { ff.hidden = true; }, 400);
    }

    openers.forEach(btn => btn.addEventListener('click', open));
    closers.forEach(btn => btn.addEventListener('click', close));
    if (skipBtn) skipBtn.addEventListener('click', close);

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        const group = opt.parentElement.querySelectorAll('.bellascena-pdp__ff-opt');
        group.forEach(g => g.classList.remove('is-active'));
        opt.classList.add('is-active');
        if (opt.hasAttribute('data-ff-usual')) state.answers.usual = opt.getAttribute('data-ff-usual');
        if (opt.hasAttribute('data-ff-fit')) state.answers.fit = opt.getAttribute('data-ff-fit');
        if (opt.hasAttribute('data-ff-note')) state.answers.note = opt.getAttribute('data-ff-note');
      });
    });

    const bandSel = ff.querySelector('[data-ff-band]');
    const cupSel = ff.querySelector('[data-ff-cup]');
    if (bandSel) bandSel.addEventListener('change', e => state.answers.band = e.target.value);
    if (cupSel) cupSel.addEventListener('change', e => state.answers.cup = e.target.value);

    if (nextBtn) nextBtn.addEventListener('click', () => {
      if (state.current === 3) { close(); return; }
      state.current += 1;
      if (state.current === 3) computeResult();
      showStep(state.current);
    });

    /* ─── Sizing logic ───────────────────────────────────
       Conservative for Asian-fit 1688 stock (runs slightly snug).
       Inputs: usual S/M/L OR EU bra (band+cup) → recommend our S/M/L/XL.
       Modifiers: fit preference, body note.
       Clamped to sizes actually available for THIS product.
    ────────────────────────────────────────────────────── */
    const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

    function bumpSize(size, delta) {
      const idx = ORDER.indexOf(size);
      if (idx < 0) return size;
      const next = Math.min(Math.max(idx + delta, 0), ORDER.length - 1);
      return ORDER[next];
    }

    /* US band sizes (30–44) → our S/M/L. Cups D and above add a size. */
    function bandCupToSize(band, cup) {
      if (!band || !cup) return null;
      const b = parseInt(band, 10);
      const cupTier = ({ A: 0, B: 0, C: 1, D: 2, DD: 2, DDD: 3 })[cup] ?? 1;
      let bandSize;
      if (b <= 30) bandSize = 'XS';
      else if (b <= 32) bandSize = 'S';
      else if (b <= 34) bandSize = 'M';
      else if (b <= 36) bandSize = 'L';
      else if (b <= 40) bandSize = 'XL';
      else bandSize = 'XXL';
      if (cupTier >= 2) bandSize = bumpSize(bandSize, 1);
      return bandSize;
    }

    /* Clamp a recommended size to what's actually available for this product.
       If exact match exists → return as-is.
       If not → return nearest available (preferring SIZE-UP over down).
       Returns { size, clamped, requested } */
    function clampToAvailable(size, available) {
      if (!available || available.length === 0) return { size, clamped: false, requested: size };
      const setAvail = new Set(available);
      if (setAvail.has(size)) return { size, clamped: false, requested: size };
      const idx = ORDER.indexOf(size);
      if (idx < 0) {
        // Fallback: just return the first available size in our order
        for (const s of ORDER) if (setAvail.has(s)) return { size: s, clamped: true, requested: size };
        return { size, clamped: false, requested: size };
      }
      // Search outward — prefer one size UP (safer for stretchy pieces)
      for (let d = 1; d < ORDER.length; d++) {
        const up = ORDER[idx + d];
        if (up && setAvail.has(up)) return { size: up, clamped: true, requested: size };
        const down = ORDER[idx - d];
        if (down && setAvail.has(down)) return { size: down, clamped: true, requested: size };
      }
      return { size, clamped: false, requested: size };
    }

    function computeResult() {
      let size = state.answers.usual;
      const fromBra = bandCupToSize(state.answers.band, state.answers.cup);
      if (fromBra) size = fromBra;
      if (!size) size = 'M';

      const notes = [];

      if (state.answers.fit === 'snug') {
        notes.push(label('ff_note_snug'));
      } else if (state.answers.fit === 'relaxed') {
        size = bumpSize(size, 1);
        notes.push(label('ff_note_relaxed'));
      }

      if (state.answers.note === 'full-bust') {
        size = bumpSize(size, 1);
        notes.push(label('ff_note_full_bust'));
      } else if (state.answers.note === 'between') {
        notes.push(label('ff_note_between'));
      } else if (state.answers.note === 'postpartum') {
        notes.push(label('ff_note_postpartum'));
      } else if (state.answers.note === 'petite') {
        notes.push(label('ff_note_petite'));
      }

      if (notes.filter(Boolean).length === 0) {
        notes.length = 0;
        notes.push(label('ff_note_default'));
      }

      // Clamp to available sizes for this product
      const availStr = ff.getAttribute('data-ff-available-sizes') || '';
      const available = availStr.split(',').map(s => s.trim()).filter(Boolean);
      const result = clampToAvailable(size, available);

      if (result.clamped) {
        notes.unshift(label('ff_note_clamped').replace('__requested__', result.requested).replace('__size__', result.size));
      }

      const sizeEl = ff.querySelector('[data-ff-result-size]');
      if (sizeEl) sizeEl.textContent = result.size;
      const metaEl = ff.querySelector('[data-ff-result-meta]');
      if (metaEl) metaEl.textContent = notes.filter(Boolean).join(' ');
    }

    showStep(0);
  }

  /* ═══════════════════════════════════════════
     ATC form → add to cart + open drawer
     ═══════════════════════════════════════════ */
  function initAtcForm() {
    const form = section.querySelector('[data-pdp-form]');
    const atc = section.querySelector('[data-pdp-atc]');
    const ctaText = section.querySelector('[data-atc-text]');
    if (!form || !atc) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atc.disabled) return;

      atc.disabled = true;
      if (ctaText) ctaText.textContent = label('adding');

      const cartDrawer = document.querySelector('cart-drawer');

      try {
        // Step 1: add to cart
        const formData = new FormData(form);
        const addRes = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const addData = await addRes.json();
        if (!addRes.ok) throw new Error(addData?.description || addData?.message || 'Add to cart failed');

        // Step 2: refresh cart drawer by fetching the section HTML via Shopify sections API
        try {
          const sectionId = cartDrawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '') || 'cart-drawer';
          // Met de markt-prefix erin. Stond hier een kale '/', dan haalde een
          // Nederlandse of Poolse klant de lade op van de standaardmarkt en
          // kreeg hij hem in het Engels terug, inclusief Engelse producttitels.
          const root = window.Shopify?.routes?.root || '/';
          const sectionRes = await fetch(root + '?section_id=' + sectionId);
          const sectionHtml = await sectionRes.text();
          // Extract the cart-drawer element from the returned HTML
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(sectionHtml, 'text/html');
          const newDrawer = newDoc.querySelector('cart-drawer');
          if (newDrawer && cartDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
            // Sync is-empty (and any other state classes) from the fresh render —
            // it lives on the <cart-drawer> element itself and otherwise goes stale
            cartDrawer.className = newDrawer.className;
          }
        } catch (refreshErr) {
          console.warn('[Bellascena] drawer refresh failed, will still open:', refreshErr);
        }

        // Step 3: open the drawer
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(atc);
          } else {
            cartDrawer.classList.add('animate', 'active');
          }
          document.body.classList.add('overflow-hidden');
        }

        if (ctaText) ctaText.textContent = label('added');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: addData }));
        setTimeout(() => {
          if (ctaText) ctaText.textContent = label('add_to_cart');
          atc.disabled = false;
        }, 1500);
      } catch (err) {
        console.error('[Bellascena] add to cart failed', err);
        if (ctaText) ctaText.textContent = label('try_again');
        setTimeout(() => {
          if (ctaText) ctaText.textContent = label('add_to_cart');
          atc.disabled = false;
        }, 2000);
      }
    });
  }

  /* ═══════════════════════════════════════════
     Init
     ═══════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initSlideWake();
    initGallery();
    initVariants();
    initFitFinder();
    initAtcForm();
  }
})();

